import { render } from "./CreateTargetModal.vue?vue&type=template&id=bba9ac16&scoped=true"
import script from "./CreateTargetModal.vue?vue&type=script&lang=js"
export * from "./CreateTargetModal.vue?vue&type=script&lang=js"

import "./CreateTargetModal.vue?vue&type=style&index=0&id=bba9ac16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba9ac16"]])

export default __exports__